import { Download, FolderDown, Trash2, Pencil, Image as ImageIcon, X } from 'lucide-react'

export interface SelectionActionBarProps {
  selectedCount: number
  currentFolderId?: string
  onSelectAll: () => void
  onRename: () => void
  onSetCover: () => void
  onDownload: () => void
  onDelete: () => void
  onDownloadAlbum: (albumId: string) => void
  onClose: () => void
}

// Presentational only: every handler arrives as a prop. The parent
// (album-list.tsx) is the one that decides whether to render this at all —
// it only mounts SelectionActionBar while `selectedPhotos.size > 0` — so
// this component itself never needs to know about "no selection".
export default function SelectionActionBar({
  selectedCount,
  currentFolderId,
  onSelectAll,
  onRename,
  onSetCover,
  onDownload,
  onDelete,
  onDownloadAlbum,
  onClose,
}: SelectionActionBarProps) {
  return (
    <div className="selection-action-bar">
      <div className="selection-info">
        <span className="selection-count">{selectedCount} selected</span>
        <button className="selection-select-all" onClick={onSelectAll}>
          Select All
        </button>
      </div>
      <div className="selection-actions">
        {selectedCount === 1 && (
          <button
            className="selection-action-btn"
            onClick={onRename}
            title="Rename"
          >
            <Pencil size={18} />
            <span>Rename</span>
          </button>
        )}
        {selectedCount === 1 && (
          <button
            className="selection-action-btn"
            onClick={onSetCover}
            title="Set as Album Cover"
          >
            <ImageIcon size={18} />
            <span>Set as Album Cover</span>
          </button>
        )}
        <button
          className="selection-action-btn"
          onClick={onDownload}
          title="Download"
        >
          <Download size={18} />
          <span>Download</span>
        </button>
        <button
          className="selection-action-btn selection-action-btn--danger"
          onClick={onDelete}
          title="Delete"
        >
          <Trash2 size={18} />
          <span>Delete</span>
        </button>
        {/*
          Everything left of this divider acts on the SELECTION; this acts
          on the whole album regardless of what is selected. The divider is
          load-bearing, not decoration -- without it this reads as one more
          selection action, which is exactly the misunderstanding that
          would make someone archive 2,000 photos by accident.
        */}
        {currentFolderId && (
          <div className="selection-album-action">
            <span className="selection-actions-divider" aria-hidden="true" />
            <button
              className="selection-action-btn"
              onClick={() => onDownloadAlbum(currentFolderId)}
              title="Download the whole album, not just the selection"
            >
              <FolderDown size={18} />
              <span>Download Album</span>
            </button>
          </div>
        )}
      </div>
      <button
        className="selection-close-btn"
        onClick={onClose}
        title="Clear selection"
      >
        <X size={20} />
      </button>
    </div>
  )
}
